import Institutions from './Institutions';

export default Institutions; 